import { useState, useEffect, useCallback } from "react";
import { useAuth } from "@/hooks/useAuth";
import { supabase } from "@/integrations/supabase/client";

type CategoryCounts = Record<string, number>;

export function useIdeaSocialProof() {
  const { membership } = useAuth();
  const [counts, setCounts] = useState<CategoryCounts>({});

  useEffect(() => {
    if (!membership?.org_id) return;
    (async () => {
      const { data } = await supabase.rpc("get_org_category_builders", {
        _org_id: membership.org_id,
      });
      if (data) {
        const map: CategoryCounts = {};
        (data as any[]).forEach((r) => {
          map[r.category] = Number(r.builder_count);
        });
        setCounts(map);
      }
    })();
  }, [membership?.org_id]);

  const getSocialProof = useCallback(
    (category: string): string | null => {
      const count = counts[category];
      if (!count || count < 1) return null;
      if (count === 1) return "1 teammate has built this type";
      return `${count} teammates have built this type`;
    },
    [counts]
  );

  return { getSocialProof };
}
